<div ng-bind-html="pdvCtrl.newdrug.hint"></div>